export default __webpack_public_path__ + "static/media/Info_Icon_yellow.c3f1d50c.svg";